import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './EQAPP_Token_Ledger.css';

const EQAPP_Token_Ledger = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"EQAPP_TOKEN_LEDGER",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	EQAPP_TOKEN_LEDGER:-1
  });


  const [EQAPP_TOKEN_LEDGER, setEQAPP_TOKEN_LEDGER] = React.useState(null);
  const [EQAPP_TOKEN_LEDGER_D, setEQAPP_TOKEN_LEDGER_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Equity Appreciation Token Token Ledger');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewEQAPP_TOKEN_LEDGER(clientInfo,"OpenNew");

		navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutEQAPP_TOKEN_LEDGER(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostEQAPP_TOKEN_LEDGER(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewEQAPP_TOKEN_LEDGER(clientInfo,"OpenNew");
		}
		navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
		if(Temp_Data2.status!="New"){
			handleDeleteEQAPP_TOKEN_LEDGER(Temp_Data2);
			navigate('/EQAPP_Token_Ledger#New',{replace:true});
		} 
		else 
			navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/EQAPP_Token_Ledger',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!EQAPP_TOKEN_LEDGER) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_${i}_SECTION`;
	  const headerId = `#EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [EQAPP_TOKEN_LEDGER]) ;


  
  
  var Ids = [];
  for(var Ele in EQAPP_TOKEN_LEDGER){
	  for(var Sec in EQAPP_TOKEN_LEDGER[Ele]){
		if(Sec == "id")
			Ids.push(EQAPP_TOKEN_LEDGER[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(EQAPP_TOKEN_LEDGER[Ele]["status"]);
		else if(Array.isArray(EQAPP_TOKEN_LEDGER[Ele][Sec]))
			  for(var Row in EQAPP_TOKEN_LEDGER[Ele][Sec])  // Convert to EQAPP_TOKEN_LEDGER[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in EQAPP_TOKEN_LEDGER[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["EQAPP_TOKEN_LEDGER"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewEQAPP_TOKEN_LEDGER(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER`).then((response1) => {
		if(!EQAPP_TOKEN_LEDGER) 
			setEQAPP_TOKEN_LEDGER(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER_D`).then((response2) => {
			setEQAPP_TOKEN_LEDGER_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddEQAPP_TOKEN_LEDGER_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewEQAPP_TOKEN_LEDGER = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setEQAPP_TOKEN_LEDGER(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataEQAPP_TOKEN_LEDGER = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutEQAPP_TOKEN_LEDGER = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostEQAPP_TOKEN_LEDGER = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteEQAPP_TOKEN_LEDGER = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/EQAPP_TOKEN_LEDGER', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["1"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["1"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["1"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["1"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("1","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["2"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("2","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["2"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("2","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["2"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("2","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["3"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("3","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["3"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("3","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["4"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("4","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["4"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("4","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  

const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["9"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0"]=value;
	Form_Data_onChange("9","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
  }; 
  

    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["9"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["9"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["9"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  
    
const EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
	Temp_Data["9"]["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4"]=value;
	//handleAddEQAPP_TOKEN_LEDGER(Temp_Data,App_Data['EQAPP_TOKEN_LEDGER']);
	Form_Data_onChange("9","EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4",value,Temp_Data);
 	//handleLastDataEQAPP_TOKEN_LEDGER(Temp_Data);
    setEQAPP_TOKEN_LEDGER(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!EQAPP_TOKEN_LEDGER) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedEQAPP_TOKEN_LEDGER =JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
  updatedEQAPP_TOKEN_LEDGER[Sec] = [...updatedEQAPP_TOKEN_LEDGER[Sec], newRow];
  setEQAPP_TOKEN_LEDGER(updatedEQAPP_TOKEN_LEDGER);
};

const handleDeleteRow = (sec,index) => {
  const updatedEQAPP_TOKEN_LEDGER = JSON.parse(JSON.stringify(EQAPP_TOKEN_LEDGER));
  updatedEQAPP_TOKEN_LEDGER[sec].splice(index, 1);
  setEQAPP_TOKEN_LEDGER(updatedEQAPP_TOKEN_LEDGER);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Equity Appreciation Token Token Ledger`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Equity Appreciation Token Ledger ID`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`EQAPP Ledger ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0" type="text" className="form-control" placeholder="EQAPP Ledger ID" value={EQAPP_TOKEN_LEDGER["1"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter EQAPP Ledger ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1" type="text" className="form-control" placeholder="Offering ID" value={EQAPP_TOKEN_LEDGER["1"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2" type="text" className="form-control" placeholder="Investor ID" value={EQAPP_TOKEN_LEDGER["1"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3" type="text" className="form-control" placeholder="Token Class ID" value={EQAPP_TOKEN_LEDGER["1"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Token Class ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Token Balance`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0" type="text" className="form-control" placeholder="Token Balance" value={EQAPP_TOKEN_LEDGER["2"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Token Balance`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Restricted Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1" type="text" className="form-control" placeholder="Restricted Token Balance" value={EQAPP_TOKEN_LEDGER["2"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Restricted Token Balance`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Available Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2" type="text" className="form-control" placeholder="Available Token Balance" value={EQAPP_TOKEN_LEDGER["2"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Available Token Balance`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Ownership Percentage Total`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Ownership Percentage Total`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0" type="text" className="form-control" placeholder="Ownership Percentage Total" value={EQAPP_TOKEN_LEDGER["3"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Ownership Percentage Total`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Income Allocation Percentage Total`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1" type="text" className="form-control" placeholder="Income Allocation Percentage Total" value={EQAPP_TOKEN_LEDGER["3"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Income Allocation Percentage Total`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Transfer Agent Record ID`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '100ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Transfer Agent Record ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0" type="text" className="form-control" placeholder="Transfer Agent Record ID" value={EQAPP_TOKEN_LEDGER["4"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '100ch' }}>
						 {t(`Enter Transfer Agent Record ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Last Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1" type="text" className="form-control" placeholder="Last Updated At" value={EQAPP_TOKEN_LEDGER["4"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Last Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0"  value={EQAPP_TOKEN_LEDGER["9"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0`]} onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1" type="text" className="form-control" placeholder="Created By" value={EQAPP_TOKEN_LEDGER["9"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2" type="text" className="form-control" placeholder="Created At" value={EQAPP_TOKEN_LEDGER["9"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3" type="text" className="form-control" placeholder="Updated By" value={EQAPP_TOKEN_LEDGER["9"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4" type="text" className="form-control" placeholder="Updated At" value={EQAPP_TOKEN_LEDGER["9"][`EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4`]} 
						onChange={EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["EQUITY_APPRECIATION_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_EQAPP_TOKEN_LEDGER_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default EQAPP_Token_Ledger;  